import { FinRepoUploadLogic } from './components/FinRepoUploadLogic';
import { compareEditedRowObjects } from '../../shared/utils/commitHandlerHelper';
import { postRequest } from '../../shared/utils';
const dbMappingCostingOpex = [
  {
    columnName: 'HTZ',
    dbAttribute: 'htz',
  },
  {
    columnName: 'NRC OPEX ME H',
    dbAttribute: 'nrc_o_me_hour',
  },
  {
    columnName: 'NRC OPEX AV H',
    dbAttribute: 'nrc_o_av_hour',
  },
  {
    columnName: 'NRC OPEX FAI H',
    dbAttribute: 'nrc_o_fai_hour',
  },
  {
    columnName: 'NRC OPEX ME €',
    dbAttribute: 'nrc_o_me_val',
  },
  {
    columnName: 'NRC OPEX AV €',
    dbAttribute: 'nrc_o_av_val',
  },
  {
    columnName: 'NRC OPEX FAI €',
    dbAttribute: 'nrc_o_fai_val',
  },
  {
    columnName: 'NRP OPEC CALCULATION METHOD',
    dbAttribute: 'nrp_o_calc_type',
  },
  {
    columnName: 'NRP CURRENCY',
    dbAttribute: 'nrp_o_currency',
  },
  {
    columnName: 'NRP OPEX ME',
    dbAttribute: 'nrp_o_me_val',
  },
  {
    columnName: 'NRP OPEX AV',
    dbAttribute: 'nrp_o_av_val',
  },
  {
    columnName: 'NRP OPEX FAI',
    dbAttribute: 'nrp_o_fai_val',
  },
  {
    columnName: 'NRP OPEX COM OFFER GROUP',
    dbAttribute: 'nrp_o_com_offer_group',
  },
  {
    columnName: 'NRP OPEX FORFEIT CATEGORY',
    dbAttribute: 'nrp_o_category',
  },
  {
    columnName: 'NRP OPEX FORFEIT',
    dbAttribute: 'nrp_o_cat_total',
  },
  {
    columnName: 'NRP OPEX FORFEIT FEE',
    dbAttribute: 'nrp_o_cat_total_w_fee',
  },
  {
    columnName: 'TARGET COP CURRENCY',
    dbAttribute: 'target_cop_cur',
  },
  {
    columnName: 'TARGET COP',
    dbAttribute: 'target_cop_value',
  },
  {
    columnName: 'RP CURRENCY',
    dbAttribute: 'rp_cur',
  },
  {
    columnName: 'RP',
    dbAttribute: 'rp_value',
  },
  {
    columnName: 'COSTING_COMMENT',
    dbAttribute: 'costing_comment',
  },
  {
    columnName: 'PROG_MGT_FEE',
    dbAttribute: 'prog_mgt_fee',
  },
  {
    columnName: 'NRP_O_BUY_IPA_VAL',
    dbAttribute: 'nrp_o_buy_ipa_val',
  },
  {
    columnName: 'NRP_O_TOTAL_VAL',
    dbAttribute: 'nrp_o_total_val',
  },
  {
    columnName: 'NRC_O_TOTAL_VAL',
    dbAttribute: 'nrc_o_total_val',
  },
  {
    columnName: 'NRP_O_PROG_MAN_VAL',
    dbAttribute: 'nrp_o_prog_man_val',
  },
  {
    columnName: 'NRC_O_PROG_MAN_VAL',
    dbAttribute: 'nrc_o_prog_man_val',
  },
  {
    columnName: 'EXCHANGE_RATE',
    dbAttribute: 'exchange_rate',
  },
];

const dbMappingCostingOffer = [
  {
    columnName: 'HTZ',
    dbAttribute: 'htz',
  },
  {
    columnName: 'COM OFFER NR',
    dbAttribute: 'nrp_o_s_com_offer_num',
  },
  {
    columnName: 'HAS PO FROM CUSTOMER',
    dbAttribute: 'nrp_o_po_for_com_offer',
  },
];

export const CommitHandler = async (props) => {
  const {
    allAccessibleColumns,
    editedRow,
    t,
    sheetData,
    featureName,
    allRows,
    editedRowOriginal,
    userDetails,
    tableDetails,
  } = props;

  const allAsyncResults: any = { success: true, data: [], errors: [] };
  const mutationTables = getMutationTable(allAccessibleColumns);
  const schemaName = tableDetails.mbdDataGrid.schemaName;
  if (editedRow?.length) {
    try {
      const updates = rowHandler(mutationTables, editedRow);
      const [viewId, mutationId] =
        mutationTables.tblfinancerepository[0].mutationTablePkey.split(':');
      const finRepoUpdateObjects = updates.map((item) => {
        const financeSet = compareEditedRowObjects(
          item.tblfinancerepository,
          editedRowOriginal,
          'fr_id',
        );
        financeSet['updated_by'] = userDetails.userId;
        financeSet['update_date'] = new Date().toISOString().substring(0, 19);
        const where = {};
        where[mutationId] = { _eq: item.tblfinancerepository[viewId] };
        return {
          where,
          _set: financeSet,
        };
      });
      const npiUpdateObjects = updates.map((item) => {
        const npiUpdate = { ...item.npi, ['npi_id']: item.rowData.npi_id };
        const npiSet = compareEditedRowObjects(npiUpdate, editedRowOriginal, 'npi_id');
        npiSet['updated_by'] = userDetails.userId;
        npiSet['update_date'] = new Date().toISOString().substring(0, 19);
        const where = {};
        where['npi_id'] = { _eq: item.rowData.npi_id };
        return {
          where,
          _set: npiSet,
        };
      });
      const financePayload = {
        pkey: mutationId,
        schema: schemaName,
        table: 'tblfinancerepository',
        updateObjects: finRepoUpdateObjects,
      };
      const npiPayload = {
        pkey: 'npi_id',
        schema: schemaName,
        table: 'npi',
        updateObjects: npiUpdateObjects,
      };

      const result = await postRequest('/api/tables', {
        screenGridId: tableDetails.id,
        tables: [npiPayload, financePayload],
      });
      if (result.errors) {
        allAsyncResults.errors.push({
          message: result.errors[0].message,
        });
        allAsyncResults.success = false;
      }
      return allAsyncResults;
    } catch (error) {
      return { success: false, data: [], errors: [{ message: error?.message }] };
    }
  }
  if (sheetData?.length) {
    try {
      const sheetTabName = getFeatureName(featureName);
      const uploadRow = DbMapping(sheetData[0][sheetTabName], featureName);

      const reqData = rowHandler(mutationTables, uploadRow);
      const val = await FinRepoLogic({
        uploadRow,
        reqData,
        t,
        featureName,
        allRows,
        tableDetails,
        userDetails,
      });
      allAsyncResults.data.push(...val.data);
      allAsyncResults.errors.push(...val.errors);
      allAsyncResults.success = val.success;
    } catch (error) {
      return allAsyncResults.errors.push(error);
    }
  }
  return allAsyncResults;
};
const getFeatureName = (featureName) => {
  return featureName === 'upload_costing_opex' ? 'IMP_COSTING_OPEX' : 'IMP_OFFER_OPEX';
};

const DbMapping = (impCostingOpex, featureName) => {
  const dbMappingAttr =
    featureName === 'upload_offer_opex' ? dbMappingCostingOffer : dbMappingCostingOpex;
  const objDetails = [];
  for (const data of impCostingOpex) {
    for (const item of dbMappingAttr) {
      [data].forEach((i) => {
        i[item.dbAttribute] = i[item.columnName];
        delete i[item.columnName];
      });
    }
    objDetails.push(data);
  }
  return objDetails;
};

const getMutationTable = (allAccessibleColumns) => {
  return allAccessibleColumns.reduce((resp, item) => {
    const { mutationTableName } = item;
    if (!mutationTableName) {
      return resp;
    }
    if (!resp?.[mutationTableName]) {
      resp[mutationTableName] = [];
    }
    resp[mutationTableName].push(item);
    return resp;
  }, {});
};

const rowHandler = (mutationTables, rowDetails) => {
  const reqData = rowDetails.reduce((data, item) => {
    const groupRecord = {};
    groupRecord['rowData'] = item;
    for (const key in mutationTables) {
      groupRecord[key] = mutationTables[key].reduce((resp, record) => {
        const { mutationColumnName, attrInternalName } = record;
        resp[mutationColumnName ?? attrInternalName] = item[attrInternalName];
        return resp;
      }, {});
    }
    data.push(groupRecord);
    return data;
  }, []);
  return reqData;
};

const FinRepoLogic = async ({
  uploadRow,
  reqData,
  t,
  featureName,
  allRows,
  tableDetails,
  userDetails,
}) => {
  let result;
  if (uploadRow?.length) {
    result = await FinRepoUploadLogic({
      uploadRow,
      reqData,
      t,
      featureName,
      allRows,
      tableDetails,
      userDetails,
    });
  }
  return result;
};
